module.exports = __webpack_public_path__ + "static/img/2_10_1.15ac1f5c.jpg";